import React from 'react';

import s from './ChipWithIcon.module.scss';

interface Props {
  label: string;
  icon: React.ReactNode;
}

export function ChipWithIcon(props: Props) {
  const { label, icon } = props;
  return (
    <div className={s.asTag}>
      {icon ? <div className={s.leftSide}>{icon}</div> : null}
      <div className={s.rightSide}>
        <span>{label}</span>
      </div>
    </div>
  );
}
